module.exports = __webpack_public_path__ + "static/sport/success.8d129a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/success.png
// module id = 4UBp
// module chunks = 0